import delay from 'delay';
import bind from 'bind-decorator';
import View from './view';

const EVENTS = [
  'change',
  'keyup',
  'paste',
  'composable_form:validate',
  'component:update'
];

export default class ComposableForm extends View {
  isDisabledValue = false;

  initialize({
    fields = [],
    components = [],
    validators = [],
    submit = 'input[type=submit]'
  }) {
    this.$fields = fields.map(field => this.$(field));
    this.components = components;
    this.validators = validators;
    this.submit = submit;

    this.on(this.events, this.validate);
    this.validate();
  }

  get isValid() {
    return this.$fields.every($input => this.isInputValid($input[0])) &&
      this.components.every(component => component.isValid) &&
      this.validators.every(validator => validator()) &&
      !this.isDisabled;
  }

  get isDisabled() {
    return this.isDisabledValue;
  }

  set isDisabled(value) {
    this.isDisabledValue = value; ;
    this.validate();
  }

  get events() {
    return EVENTS.join(' ');
  }

  // made getter in order to use ComposableForm inside of vue components,
  // so submit button node can be changed by vue
  get $submit() {
    return this.$(this.submit);
  }

  @bind
  async validate() {
    await delay(1);
    // a vue modal swaps the form branch out after a successful submit — a detached form has nothing to validate
    if (!this.node?.isConnected) { return; }
    this.$submit.prop('disabled', !this.isValid);
  }

  destroy() {
    this.off(this.events, this.validate);
    this.components.forEach(component => {
      if (typeof component.destroy === 'function') {
        component.destroy();
      }
    });
  }

  isInputValid(input) {
    return input.disabled || (input.type === 'checkbox' ?
      input.checked :
      !!input.value
    );
  }
}
